import useSWR from "swr";
import { type Section } from "~/api/types";
import { getJson } from "../api/requests";

export function useSections() {
  return useSWR<Section[], Error>("/sections", (path: string) =>
    getJson<Section[]>(path),
  );
}
